module.exports = __webpack_public_path__ + "static/FoodForHungry-ca7a01536d09ff16d16fe30a4bf623db.png";